import cc from 'classcat'
import React, { PropsWithChildren } from 'react'

import { reactClass } from '../../../../utils'
import * as Styled from './styles'

type ActionOverlayProps = {
  className?: string
  css?: any
  forceEnabled?: boolean
  hoverable?: boolean
  placement?: 'left' | 'right'
  width?: string
}

export const MatchListRowActionOverlay = ({
  children,
  className,
  forceEnabled,
  hoverable,
  placement = 'left',
  width = '64px',
}: PropsWithChildren<ActionOverlayProps>) => {
  return (
    <Styled.MatchListRowActionOverlayWrapper
      forceEnabled={forceEnabled}
      hoverable={hoverable}
      placement={placement}
      width={width}
      className={cc([
        className,
        reactClass(['action-overlay', hoverable ? 'hoverable' : '', forceEnabled ? 'force-enabled' : ''].join(' ')),
      ])}
    >
      {children}
    </Styled.MatchListRowActionOverlayWrapper>
  )
}
